import React from 'react';

const GraphsIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.999609 0.349609C0.640624 0.349609 0.349609 0.640624 0.349609 0.999609V18.7688C0.349609 19.7981 0.758475 20.7852 1.48626 21.513C2.21405 22.2407 3.20113 22.6496 4.23038 22.6496H21.9996C22.3586 22.6496 22.6496 22.3586 22.6496 21.9996C22.6496 21.6406 22.3586 21.3496 21.9996 21.3496H4.23038C3.54592 21.3496 2.88949 21.0777 2.4055 20.5937C1.92151 20.1097 1.64961 19.4533 1.64961 18.7688V0.999609C1.64961 0.640624 1.35859 0.349609 0.999609 0.349609ZM16.4272 4.84961C16.1082 4.84961 15.8496 5.10822 15.8496 5.42724C15.8496 5.74626 16.1082 6.00487 16.4272 6.00487H19.0151L12.4996 12.1536L9.75115 9.55986C9.49984 9.32269 9.09579 9.32269 8.84448 9.55986L4.04179 14.0922C3.78555 14.334 3.78555 14.7299 4.04179 14.9717C4.2931 15.2089 4.69715 15.2089 4.94846 14.9717L9.29782 10.8672L12.0463 13.4609C12.2976 13.6981 12.7016 13.6981 12.9529 13.4609L19.9943 6.81586V9.57198C19.9943 9.89099 20.253 10.1496 20.572 10.1496C20.891 10.1496 21.1496 9.89099 21.1496 9.57198V5.42724C21.1496 5.10822 20.891 4.84961 20.572 4.84961H16.4272Z"
      fill="#413B56"
    />
  </svg>
);

export default GraphsIcon;
